import React from 'react'
import Fragment from '../common/fragment'


function FragmentBI(props) {
  return (
    <Fragment pos="ii" {...props}>
      <p>
Las abejas no vuelan, excavan. Sus panales son abismos profundos, rocas
encalladas, cuevas secretas.
      </p>
    </Fragment>
  )
}


export default FragmentBI
